// War impact data - Before and after October 7, 2023
// Content is purely humanitarian, focusing on resilience and hope

export interface ImpactMetric {
  key: string;
  before: {
    value: string;
    description: {
      en: string;
      ar: string;
    };
  };
  after: {
    value: string;
    description: {
      en: string;
      ar: string;
    };
  };
}

export const warImpact = {
  overview: {
    en: "Champions Academy has been a cornerstone of sports development in Gaza since 2015. The events of October 7, 2023, and their aftermath have significantly impacted our operations, facilities, and community. Despite these challenges, our spirit remains unbroken.",
    ar: "كانت أكاديمية تشامبيونز حجر الزاوية في تطوير الرياضة في غزة منذ عام 2015. أثرت أحداث 7 أكتوبر 2023 وما تلاها بشكل كبير على عملياتنا ومرافقنا ومجتمعنا. رغم هذه التحديات، تبقى روحنا صامدة."
  },
  
  metrics: [
    {
      key: "activePlayers",
      before: {
        value: "7,500+",
        description: {
          en: "Active players training across all branches",
          ar: "لاعب نشط يتدرب في جميع الفروع"
        }
      },
      after: {
        value: "Limited",
        description: {
          en: "Operations significantly reduced due to circumstances",
          ar: "العمليات انخفضت بشكل كبير بسبب الظروف"
        }
      }
    },
    {
      key: "operationalBranches",
      before: {
        value: "7",
        description: {
          en: "Fully operational branches across Gaza",
          ar: "فرع يعمل بكامل طاقته في جميع أنحاء غزة"
        }
      },
      after: {
        value: "Affected",
        description: {
          en: "Multiple facilities impacted",
          ar: "تأثرت مرافق متعددة"
        }
      }
    },
    {
      key: "coachingStaff",
      before: {
        value: "180+",
        description: {
          en: "Dedicated coaches and staff members",
          ar: "مدرب وموظف متفاني"
        }
      },
      after: {
        value: "Displaced",
        description: {
          en: "Many staff displaced, continuing remotely when possible",
          ar: "العديد من الموظفين نازحون، يستمرون عن بُعد عند الإمكان"
        }
      }
    },
    {
      key: "programs",
      before: {
        value: "7",
        description: {
          en: "Sports programs running daily",
          ar: "برنامج رياضي يعمل يومياً"
        }
      },
      after: {
        value: "Paused",
        description: {
          en: "Programs temporarily paused, planning for resumption",
          ar: "البرامج متوقفة مؤقتاً، نخطط للاستئناف"
        }
      }
    }
  ] as ImpactMetric[],
  
  facilityImpact: {
    en: "Our 26,000 sq m main facility and several branch locations have been affected by the ongoing situation. We are documenting all damages and preparing for eventual reconstruction.",
    ar: "تأثر مرفقنا الرئيسي البالغ 26,000 متر مربع والعديد من مواقع الفروع بالوضع المستمر. نوثق جميع الأضرار ونستعد لإعادة البناء في نهاية المطاف."
  },
  
  communityResponse: {
    en: "Despite the challenges, our Champions family has shown remarkable resilience. We continue to support our athletes, staff, and their families through these difficult times, providing what assistance we can.",
    ar: "رغم التحديات، أظهرت عائلة تشامبيونز صموداً ملحوظاً. نستمر في دعم رياضيينا وموظفينا وعائلاتهم خلال هذه الأوقات الصعبة، نقدم ما نستطيع من مساعدة."
  },
  
  hopeMessage: {
    en: "Sports has always been a source of hope, unity, and healing. We believe that through the resilience of our community and the support of our partners, Champions Academy will rise again. We will continue our mission of developing young athletes and serving our community. Together, we remain ONE TEAM ONE DREAM.",
    ar: "كانت الرياضة دائماً مصدراً للأمل والوحدة والشفاء. نؤمن أنه من خلال صمود مجتمعنا ودعم شركائنا، ستنهض أكاديمية تشامبيونز مجدداً. سنستمر في مهمتنا لتطوير الرياضيين الشباب وخدمة مجتمعنا. معاً، نبقى فريقاً واحداً حلماً واحداً."
  },
  
  wayForward: {
    en: "We are committed to rebuilding and continuing our mission. With the support of our international partners and the global sports community, we will restore our programs and facilities. Until then, we remain focused on supporting our displaced athletes and staff.",
    ar: "نحن ملتزمون بإعادة البناء ومواصلة مهمتنا. بدعم شركائنا الدوليين ومجتمع الرياضة العالمي، سنستعيد برامجنا ومرافقنا. حتى ذلك الحين، نركز على دعم رياضيينا وموظفينا النازحين."
  }
};
